module.exports = __webpack_public_path__ + "static/img/8.1e976a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/sp/8.png
// module id = Lk07
// module chunks = 0